module.exports = new __parcel__URL__("cornershop-design-principles.dd3ce86f.png").toString();